// 添加弹框视频

function popu(ele, type) {
  for (var i = 0; i < ele.length; i++) {
    ele[i].addEventListener("click", function (e) {
      e.preventDefault();
      var header = document.getElementsByTagName("header")[0];
      var main = document.getElementsByTagName("main")[0];
      var footer = document.getElementsByTagName("footer")[0];
      var body = document.getElementsByTagName("body")[0];
      var w = document.createElement("aside");
      var p = document.createElement("div");
      var f = document.createElement("iframe");
      document.body.style.overflow='hidden';
      document.body.style.height='100vh';
      w.setAttribute("id", "popu-cont");
      if (type === "video") {
        w.innerHTML = '<div class="popu-mask" style="position: fixed;width: 100%;height: 100%;left: 0;right: 0;z-index: 1;"></div><div class="popu-wrap text-center"><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"><path d="M11 11V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5z"></path></use> </svg></div>';
        var href = this.getAttribute("href");
        f.setAttribute("src", href);
        f.setAttribute("allow", "autoplay; encrypted-media");
        f.setAttribute("allowfullscreen", "allowfullscreen");
        // f.setAttribute("autoplay", "false");
        w.querySelector(".popu-wrap").appendChild(f);
        w.querySelector(".popu-wrap").appendChild(p);

      } else if (type === "image") {
        w.innerHTML = '<div class="popu-wrap text-center"><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"></use> </svg></div>';
        w.querySelector(".popu-wrap").appendChild(this.cloneNode(!0))
      } else if (type === "image-other") {
        w.innerHTML = '<div class="popu-wrap popu-wrap-other text-center"><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"></use> </svg></div>';
        w.querySelector(".popu-wrap").appendChild(this.cloneNode(!0))
      }
      w.querySelector(".popu-wrap").classList.add(type);
      body.appendChild(w);
      clickCloseAll(".close-btn");
      clickCloseAll(".popu-mask");
      function clickCloseAll(className) {
        document.querySelector(className).addEventListener('click', function (e) {
        document.body.style='';
          if (isIE()) {
            document.getElementById("popu-cont").removeNode(!0)
          } else {
            document.getElementById("popu-cont").remove()
          }
        })
      }
      function isIE() {
        if (!!window.ActiveXobject || "ActiveXObject" in window) {
          return !0
        } else {
          return !1
        }
      }
    })
  }
}
popu(document.getElementsByClassName('popu-video'), "video");
function textDialog(ele) {
  for (var i = 0; i < ele.length; i++) {
    ele[i].addEventListener("click", function (e) {
      e.preventDefault();
      var body = document.getElementsByTagName("body")[0];
      var w = document.createElement("aside");
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
      w.setAttribute("id", "popu-cont");
      w.setAttribute("class", "popu-cont-cutom popu-cont-cutom-txt");
      w.innerHTML = `<div class="popu-mask" style="position: fixed;width: 100%;height: 100%;left: 0;right: 0;z-index: 1;"></div>
      <div class="popu-wrap text-center"><svg width="32" height="32" viewBox="0 0 24 24" class="transition-linear close-btn"> <use xlink:href="#close-path"><path d="M11 11V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5z"></path></use> </svg>
        <div class="popup_text-contend">
          <p style="margin-top: 0pt; margin-bottom: 0pt; page-break-inside: avoid; page-break-after: avoid; line-height: 170%; widows: 0; orphans: 0; font-size: 24pt;"><span style="font-weight: bold; color: #1a1a1a;">Sommerverkauf - Regeln für das Giveaway</span></p>
          <p style = "margin-top: 3pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt;" > <span style="font-weight: bold; color: #333333;">Mit diesem Giveaway möchten wir uns bei unseren wertvollen Kunden für ihre Unterstützung bedanken.</span></ >
          <p style="margin-top: 3pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt;"><span style="font-weight: bold; color: #333333;">Ein höherer Kaufbetrag erhöht NICHT Ihre Chance, den Preis zu gewinnen. </span></p>
          <p style="margin-top: 3pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt;"><span style="color: #333333;">&nbsp;</span></p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt;">
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Zuschussfähigkeit:</span><span> An dem Giveaway (das "Giveaway") können nur Personen teilnehmen, die sich auf der Online-Sommerverkaufsseite anmelden, während des Sommerverkaufs eine Bestellung auf de.ulike.com aufgeben und zum Zeitpunkt der Teilnahme mindestens 18 Jahre alt sind. Das Gewinnspiel gilt für Personen mit Wohnsitz in den Vereinigten Staaten von </span><span style="font-weight: bold;">Amerika, dem Vereinigten Königreich und Europa</span><span> und ist nichtig, wo es gesetzlich verboten ist und wo es handelsübliche Einschränkungen gibt. Mitarbeiter von Ulike (der "Sponsor"), deren jeweilige Partner, Tochtergesellschaften, Werbe- und Promotionsagenturen, Lieferanten und deren unmittelbare Familienangehörige und/oder im selben Haushalt lebende Personen sind von der Teilnahme an diesem Gewinnspiel ausgeschlossen. Die Verlosung unterliegt allen anwendbaren Bundes-, Landes- und lokalen Gesetzen und Vorschriften. Ungültig wo verboten.</span>
          </li>
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Zustimmung zu den Regeln:</span><span> Durch Ihre Teilnahme erklären Sie sich damit einverstanden, dass Sie an diese Regeln vollständig und bedingungslos gebunden sind, und Sie erklären und garantieren, dass Sie die hierin festgelegten Teilnahmebedingungen erfüllen. Darüber hinaus erklären Sie sich damit einverstanden, die Entscheidungen von Ulike in Bezug auf den Inhalt als endgültig und bindend zu akzeptieren. Das Gewinnspiel unterliegt allen geltenden Bundes-, Landes- und Kommunalgesetzen.</span>
          </li>
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Laufzeit des Gewinnspiels:</span><span> Online-Teilnahmen sind ab dem 8. Juni 2023 um 00:00 Uhr bis zum 28. Juni 2023 um 23:59 Uhr möglich. Alle Online-Teilnahmen müssen bis zum 28. Juni 2023 um 23:59 Uhr eingegangen sein. Alle Zeitangaben beziehen sich auf Eastern Time ("ET") (US & Kanada).</span>
          </li>
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Wie man teilnimmt:</span><span> Die Teilnahme an dem Gewinnspiel erfolgt durch die Angabe einer E-Mail-Adresse und den Kauf eines der Produkte auf dieser Website. Um einen Preis zu gewinnen, muss der Beitrag alle angegebenen Bedingungen erfüllen. Einsendungen, die nicht vollständig sind oder nicht den Regeln oder Spezifikationen entsprechen, können nach dem alleinigen Ermessen von Ulike disqualifiziert werden. Pro Person, pro Haushalt und pro E-Mail-Adresse ist während des gesamten Gewinnspielzeitraums nur eine (1) Teilnahme möglich. Sie dürfen nicht öfter als angegeben teilnehmen, indem Sie mehrere E-Mail-Adressen, Identitäten oder Geräte verwenden, um die Regeln zu umgehen. Wenn Sie betrügerische Methoden anwenden oder auf andere Weise versuchen, die Regeln zu umgehen, kann Ihre Teilnahme nach alleinigem Ermessen von Ulike ausgeschlossen werden.</span>
          </li>
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Preise:</span><span> </span><span style="text-decoration: underline;">Hauptpreis (1)</span><span>: Eine (1) $10.200,00 Chanel 2.55 Tasche, </span><span style="text-decoration: underline;">Erster Preis (2)</span><span>: Ein (1) $1.800,00 Chanel COCO ARMBAND, </span><span style="text-decoration: underline;">Zweiter Preis (4)</span><span>: Eine $650 Chanel ECHTECKIGE SONNENBRILLE, </span><span style="text-decoration: underline;">Dritter Preis (30)</span><span>: Eine kostenlose Bestellung (Wert je nach Bestellung). Sie haben keine Garantie, einen Preis zu gewinnen, und Ihre Gewinnchancen hängen von der Gesamtzahl der eingegangenen teilnahmeberechtigten Beiträge ab. Der tatsächliche/geschätzte Wert kann zum Zeitpunkt der Preisvergabe abweichen. Die Einzelheiten des Preises werden ausschließlich vom Sponsor festgelegt. Ein Ersatz des Preises durch Bargeld oder andere Preise ist nur nach Ermessen des Sponsors zulässig. Der Preis ist nicht übertragbar. Der Gewinner trägt die alleinige Verantwortung für alle mit dem Preis verbundenen Kosten, einschließlich und ohne Einschränkung aller Bundes-, Landes- und lokalen Steuern. Ein Ersatz des Preises oder eine Übertragung/Abtretung des Preises an andere oder die Forderung nach dem Gegenwert in bar durch die Gewinner ist nicht gestattet. Die Annahme des Preises stellt die Erlaubnis für Ulike dar, den Namen, das Bild und den Beitrag des Gewinners für Werbe- und Handelszwecke ohne weitere Vergütung zu verwenden, sofern dies nicht gesetzlich verboten ist.</span>
          </li>
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Quoten:</span><span> Die Gewinnchancen hängen von der Anzahl der teilnahmeberechtigten Einsendungen ab.</span>
          </li>
          </ol>
          <ol start="7" type="1" style="margin: 0pt; padding-left: 0pt;">
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Auswahl und Benachrichtigung des Gewinners</span><span>: Die Gewinner des Gewinnspiels werden am 5. Juli 2023 unter der Aufsicht des Sponsors per Zufallsprinzip ermittelt. Die Gewinner werden innerhalb von fünf (5) Tagen nach der Auswahl des Gewinners per E-Mail an die E-Mail-Adresse benachrichtigt, mit der sie an der Verlosung teilgenommen haben. Ulike übernimmt keine Haftung für den Fall, dass ein Gewinner aufgrund von Spam-, Junk-E-Mail- oder anderen Sicherheitseinstellungen keine Benachrichtigung erhält oder dass der Gewinner falsche oder anderweitig nicht funktionierende Kontaktinformationen angegeben hat. Kann der ausgewählte Gewinner nicht kontaktiert werden, ist er nicht teilnahmeberechtigt, fordert er den Preis nicht innerhalb von 15 Tagen nach Versand der Gewinnbenachrichtigung an oder sendet er die ausgefüllte und unterschriebene Erklärung und die Freigaben nicht rechtzeitig zurück, kann der Preis verfallen und ein anderer Gewinner ausgewählt werden. Der Erhalt des im Rahmen dieses Gewinnspiels angebotenen Preises durch den Gewinner ist an die Einhaltung aller Bundes- und Landesgesetze und -vorschriften geknüpft. JEGLICHER VERSTOSS GEGEN DIESE OFFIZIELLEN REGELN DURCH EINEN GEWINNER (NACH EINEM EINZIGEN EIGENEN ERMESSEN DES SPONSORS) WIRD DESSEN AUSSCHLUSS ALS GEWINNER DES GESCHENKES FÜHREN UND ALLE VORTEILE ALS GEWINNER WERDEN UNMITTELBAR BEENDET WERDEN. </span>
          </li>
          </ol>
          <p style="margin-top: 3pt; margin-left: 16.8pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt;"><span style=">DAS 90-TÄGIGE RÜCKGABERECHT OHNE RÜCKFRAGE GILT NICHT FÜR DEN GEWINNER. </span></p>
          <ol start="8" type="1" style="margin: 0pt; padding-left: 0pt;">
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Von Ihnen gewährte Rechte</span><span>: Mit der Teilnahme an diesem Inhalt erklären Sie sich damit einverstanden, dass Ulike, jeder, der im Namen von Ulike handelt, oder seine jeweiligen Lizenznehmer, Nachfolger und Bevollmächtigten das Recht haben, soweit gesetzlich zulässig, ohne weitere Ankündigung, Prüfung oder Zustimmung Ihren Beitrag, einschließlich, aber nicht beschränkt auf den Beitrag und den Namen und die E-Mail-Adresse des Gewinners, weltweit in allen bekannten oder zukünftigen Medien für Nachrichten, Werbung oder Informationen und für Handels-, Werbe-, Public-Relations- und Promotionszwecke zu drucken, zu veröffentlichen, auszustrahlen, zu verbreiten und zu nutzen.</span>
          </li>
          <li style="margin-top: 3pt; margin-left: 13.21pt; margin-bottom: 3pt; widows: 0; orphans: 0; padding-left: 3.59pt; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Bedingungen</span><span>: Ulike behält sich das Recht vor, das Gewinnspiel nach eigenem Ermessen abzubrechen, zu beenden, zu modifizieren oder auszusetzen, wenn (nach eigenem Ermessen) ein Virus, Bugs, nicht autorisierte menschliche Eingriffe, Betrug oder andere Ursachen außerhalb der Kontrolle von Ulike die Verwaltung, Sicherheit, Fairness oder ordnungsgemäße Durchführung des Gewinnspiels beeinträchtigen. In einem solchen Fall kann Ulike die Empfänger aus allen zulässigen Einsendungen auswählen, die vor und/oder (gegebenenfalls) nach der von Ulike getroffenen Maßnahme eingegangen sind. Ulike behält sich das Recht vor, nach eigenem Ermessen jede Person zu disqualifizieren, die den Teilnahmeprozess oder den Betrieb des Gewinnspiels oder der Website manipuliert oder versucht zu manipulieren oder gegen diese Bedingungen verstößt.</span>
          </li>
          </ol>
          <p style="margin-top: 3pt; margin-left: 16.8pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt;"><span style="color: #333333;">Ulike behält sich das Recht vor, nach eigenem Ermessen und zur Wahrung der Integrität des Gewinnspiels Abstimmungen aus jeglichem Grund für ungültig zu erklären, einschließlich, aber nicht beschränkt auf: mehrfache Teilnahmen desselben Benutzers von verschiedenen IP-Adressen aus; mehrfache Teilnahmen vom selben Computer aus, die über die nach den Gewinnspielregeln zulässige Anzahl hinausgehen; oder die Verwendung von Bots, Makros oder Skripten oder anderen technischen Mitteln zur Teilnahme. Jeder Versuch eines Teilnehmers, eine Website absichtlich zu schädigen oder den rechtmäßigen Ablauf des Gewinnspiels zu untergraben, kann einen Verstoß gegen straf- und zivilrechtliche Bestimmungen darstellen. Sollte ein solcher Versuch unternommen werden, behält sich Ulike das Recht vor, von einer solchen Person im vollen gesetzlich zulässigen Umfang Schadensersatz zu verlangen.</span></p>
          <p style="margin-top: 3pt; margin-left: 16.8pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt;"><span style="color: #333333;">Mit der Teilnahme an dem Gewinnspiel erklären Sie sich damit einverstanden, in regelmäßigen Abständen E-Mail-Newsletter von Ulike zu erhalten. Sie können sich jederzeit vom Erhalt dieser Mitteilung abmelden, indem Sie auf den Abmeldelink im Newsletter klicken.</span></p>
          <ol start="10" type="1" style="margin: 0pt; padding-left: 0pt;">
          <li style="margin-top: 3pt; margin-left: 16.8pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Beschränkung der Haftung</span><span>: Mit der Teilnahme erklären Sie sich damit einverstanden, Ulike und seine Tochtergesellschaften, verbundenen Unternehmen, Werbe- und Promotionsagenturen, Partner, Vertreter, Agenten, Nachfolger, Abtretungsempfänger, Angestellten, leitenden Angestellten und Direktoren von jeglicher Haftung, Krankheit, Verletzung, Tod, Verlust, Rechtsstreitigkeiten, Ansprüchen oder Schäden freizustellen und schadlos zu halten, die direkt oder indirekt auftreten können, (i) die Teilnahme des Teilnehmers an der Verlosung und/oder die Annahme, der Besitz, die Verwendung oder der Missbrauch eines Preises oder eines Teils davon, (ii) technische Störungen jeglicher Art, einschließlich, aber nicht beschränkt auf das Versagen von Computern, Kabeln, Netzwerken, Hardware oder Software; (iii) Nichtverfügbarkeit oder Nichterreichbarkeit von Übertragungen oder Telefon- oder Internetdiensten; (iv) unbefugtes menschliches Eingreifen in irgendeinen Teil des Teilnahmeverfahrens oder der Werbeaktion; (v) elektronisches oder menschliches Versagen, das bei der Verwaltung der Werbeaktion oder der Verarbeitung der Einsendungen auftreten kann.</span>
          </li>
          <li style="margin-top: 3pt; margin-left: 16.8pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Datenschutz</span><span>: Die mit einem Beitrag übermittelten Informationen unterliegen den Datenschutzerklärungen, die auf der Ulike-Website angegeben sind. Lesen Sie die Datenschutzerklärung hier: </span><a href="https://de.ulike.com/pages/privacy-policy" target="dlt" style="text-decoration: none;"><span style="text-decoration: underline; color: #0563c1;"> [Offiziell] Datenschutz - Ulike </span></a>
          </li>
          </ol>
          <ol start="12" type="1" style="margin: 0pt; padding-left: 0pt;">
          <li style="margin-top: 3pt; margin-left: 16.8pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt; color: #333333;">
          <span style="font-weight: bold;">Liste der Gewinner</span><span>: Die Gewinner werden auf der Sommerverkaufsseite und in unserem offiziellen sozialen Netzwerk bekannt gegeben. Um die Namen der Gewinner zu erfahren, kontaktieren Sie uns bitte unter und geben Sie im Text der E-Mail "Bitte senden Sie mir die Gewinnerliste für die Ulike-Giveaway-Aktion" ein.</span>
          </li>
          <li style="margin-top: 3pt; margin-left: 16.8pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt; font-weight: bold;"><span>Sponsor: Der Sponsor des Gewinnspiels ist </span></li>
          </ol>
          <p style="margin-top: 3pt; margin-left: 16.8pt; margin-bottom: 3pt; widows: 0; orphans: 0; font-size: 11pt;"><span>AMERICA ULIKE INTERNATIONAL INC., 300 Lenora Street #1096, Seattle, WA 98121, United States.</span></p>
        </div>
      </div>`;
      // 将视频源元素添加到视频元素中
      body.appendChild(w);
      clickCloseAll(".close-btn");
      clickCloseAll(".popu-mask");
      function clickCloseAll(className) {
        document.querySelector(className).addEventListener('click', function (e) {
          document.body.style = '';
          if (isIE()) {
            document.getElementById("popu-cont").removeNode(!0)
          } else {
            document.getElementById("popu-cont").remove()
          }
        })
      }
      function isIE() {
        if (!!window.ActiveXobject || "ActiveXObject" in window) {
          return !0
        } else {
          return !1
        }
      }
    })
  }
}

textDialog(document.getElementsByClassName('slideshow__btn-link'));

/**
 * 
 * @param {产品id} productId 
 * @param {按钮是否需要动画} button 
 * @param {扩展字段} properties 
 * @returns 
 */
function addToCart(productId, button, properties, quantity = 1) {
  // 获取文本元素和加载动画元素
 let textElement ;
 let loaderElement;
  if(button){
    textElement = button.querySelector('.loader-button__text');
    loaderElement = button.querySelector('.loader-button__loader');

     if(button.disabled) return
     // 禁用按钮
     button.setAttribute("disabled", "disabled");
     button.setAttribute("aria-busy", "true");
     // 显示加载动画
     textElement.hidden = true;
     loaderElement.hidden = false;
  }

  console.log(properties);

 fetch('/cart/add.js', {
   method: 'POST',
   headers: {
     'Content-Type': 'application/json',
   },
   body: JSON.stringify({
     id: productId,
     quantity: quantity, // 可根据需求设置购买数量
     properties
   }),
 })
   .then(response => response.json())
   .then(data => {
     // 添加购物车成功后的处理逻辑
     console.log('Product added to cart:', data);
     // 获取购物车列表
     fetch('/cart.js')
       .then(response => response.json())
       .then(cartData => {
         // 获取购物车列表成功后的处理逻辑
         console.log('Cart contents:', cartData);
         cartData["sections"] = data["sections"];
         document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
           bubbles: true,
           detail: {
             cart: cartData,
             openMiniCart: window.themeVariables.settings.cartType === "drawer"
           }
         }));
          if(button){
           // 恢复按钮状态
           button.removeAttribute("disabled");
           button.removeAttribute("aria-busy");
           // 显示 "Add to Cart"，隐藏加载动画
           textElement.hidden = false;
           loaderElement.hidden = true;
          }
       })
       .catch(error => {
         // 获取购物车列表失败的处理逻辑
         console.error('Error getting cart contents:', error);
         if(button){
           // 恢复按钮状态
           button.removeAttribute("disabled");
           button.removeAttribute("aria-busy");
           // 显示 "Add to Cart"，隐藏加载动画
           textElement.hidden = false;
           loaderElement.hidden = true;
         }
       });
   })
   .catch(error => {
     // 添加购物车失败的处理逻辑
     console.error('Error adding product to cart:', error);
   });
}

// 加购处理回调
function addToCartPromise(
  productId,
  button,
  properties,
  code = "",
  quantity = 1
) {
  return new Promise((resolve, reject) => {
    // 获取文本元素和加载动画元素
    var textElement;
    var loaderElement;
    if (button) {
      textElement = button.querySelector(".loader-button__text");
      loaderElement = button.querySelector(".loader-button__loader");

      if (button.disabled) return;
      // 禁用按钮
      button.setAttribute("disabled", "disabled");
      button.setAttribute("aria-busy", "true");
      // 显示加载动画
      textElement.hidden = true;
      loaderElement.hidden = false;
    }

    console.log(properties);

    if (code) {
      autoDiscountCode(code);
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity, // 可根据需求设置购买数量
        properties,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // 获取购物车列表
        return fetch("/cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            cartData["sections"] = data["sections"];
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartData,
                  openMiniCart:
                    window.themeVariables.settings.cartType === "drawer",
                },
              })
            );

            if (button) {
              // 恢复按钮状态
              button.removeAttribute("disabled");
              button.removeAttribute("aria-busy");
              // 显示 "Add to Cart"，隐藏加载动画
              textElement.hidden = false;
              loaderElement.hidden = true;
            }

            // Resolve the Promise with the cart data
            resolve(cartData);
          });
      })
      .catch((error) => {
        console.error(
          "Error adding product to cart or getting cart contents:",
          error
        );

        if (button) {
          // 恢复按钮状态
          button.removeAttribute("disabled");
          button.removeAttribute("aria-busy");
          // 显示 "Add to Cart"，隐藏加载动画
          textElement.hidden = false;
          loaderElement.hidden = true;
        }

        // Reject the Promise with the error
        reject(error);
      });
  });
}

function buyProduct(productId, properties) {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(() => {
    // 购物车已清空，跳转到结账页面
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1, // 可根据需求设置购买数量
        properties
      }),
    })
    .then(response => response.json())
    .then(data => {
      fetch('/checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: productId,
          quantity: 1,
          form_type: 'product',
          utf8: '✓'
        }),
      })
      .then(response => {
        console.log('response', response)
        if (response.status === 302) {
          // 获取重定向的 URL
          const redirectUrl = response.headers.get('Location');
          // 执行重定向
          window.location.href = redirectUrl;
        } else {
          // 处理其他状态码的逻辑
          return response
        }
      })
      .then(data => {
        // 处理购买成功后的逻辑
        console.log('Purchase successful:', data);
         // 执行跳转
         window.location.href = data.url;
        // 可以根据需求执行其他操作，例如显示购买成功提示、跳转到订单页面等
      })
      .catch(error => {
        // 处理购买失败的逻辑
        console.error('Purchase failed:', error);
        // 可以根据需求执行其他错误处理操作
      });
    }).catch(error => {
    // 添加购物车失败，处理错误
    console.error('Error clearing cart:', error);
  });
    
  })
  .catch(error => {
    // 清空购物车失败，处理错误
    console.error('Error clearing cart:', error);
  });
}


//复制折扣码方法 start
function copyCode(code, codeTxt, bt){
  navigator.clipboard.writeText(code);
  bt.innerHTML = 'Kopiert';
 setTimeout(()=>{
  bt.innerHTML = codeTxt;
 },7000)
}
//复制折扣码方法 start
function copyCodeExtend(code, codeTxt, bt,event){
  // 阻止默认事件
  event.preventDefault();
  event.stopPropagation();
  navigator.clipboard.writeText(code);
  bt.innerHTML = 'Kopiert';
 setTimeout(()=>{
  bt.innerHTML = codeTxt;
 },7000)
}

class ImgPlay {
  constructor(cont,urlRoot,maxLength) {
    this.urlRoot = urlRoot;
    this.indexRange = [0, maxLength - 1];
    this.maxLength = maxLength
    this.eleContainer = document.querySelector(cont);
    this.percent = 0
    this.store = {
      length: 0
    }
    this.isPlay = false
    this.pictureNum = null
  }

  loadImg(){
    // 图片序列预加载
    for ( let start = this.indexRange[0]; start <= this.indexRange[1]; start++) {
        ((index)=> {
          let that = this
          let img = new Image();
            img.onload = function () {
                that.store.length++;
                // 存储预加载的图片对象
                that.store[index] = this;
                that.updateLoading();
            };
            img.onerror = function () {
              that.store.length++;
              that.updateLoading();
            };
            img.src = that.urlRoot + index + '.jpg';
        })(start);
    }
  }

  updateLoading(){
    // loading进度
    this.percent = Math.round(100 * this.store.length / this.maxLength);
    if(this.percent == 100 && this.isPlay){
      this.playImg(this.pictureNum)
    }
  }

  playImg(num = null){
    // 全部加载完毕，无论成功还是失败
    if (this.percent == 100) {
      let index = num || this.indexRange[0];
      this.eleContainer.innerHTML = '';
      // 依次append图片对象
      let step = ()=> {
          if (this.store[index - 1] && num == null) {
              this.eleContainer.removeChild(this.store[index - 1]);
          }
          this.eleContainer.appendChild(this.store[index]);
          // 序列增加
          index++;
          // 如果超过最大限制
          if (index <= this.indexRange[1]) {
            if(num == null){
              setTimeout(step, 42);
            }else{

            }
          } else {
              // 本段播放结束回调
              // 我这里就放一个重新播放的按钮
              // this.eleContainer.insertAdjacentHTML('beforeEnd', '<button onclick="">再看一遍</button>');
          }
      };
      if(num == null){
        // 等100%动画结束后执行播放
        setTimeout(step, 100);
      }else{
        step()
      }
      
    }else{
      this.isPlay = true
      this.pictureNum = num
    }
  }
}

 // 定义函数来滚动到特定的 section
function scrollToSection(sectionId) {
  var section = document.getElementById(sectionId);
  section.scrollIntoView({ behavior: 'smooth' });
}

class Countdown {
  constructor(endTime, elName,loop = null) {
    this.displayElement = document.querySelector(elName);
    this.timer = null;
    this.loop = loop
    this.setEndTime(endTime);
    this.start();
    this.locaName = elName+'loopTime'
  }
  setEndTime(endTime) {
    if (endTime) {
      this.endTime = new Date(endTime).getTime();
    } else {
      if(this.loop){
        let locTime = localStorage.getItem(this.locaName);
        if(locTime && locTime*1 > new Date().getTime()){
          this.endTime = locTime*1
        }else{
          this.endTime = new Date().getTime() + 2 * 24 * 60 * 60 * 1000;
          localStorage.setItem(this.locaName, this.endTime)
        }
      }else{
        this.endTime = new Date().getTime();
      }
    }
  }
  start() {
    this.timer = setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date().getTime();
    const distance = this.endTime - now;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (distance < 0) {
      if(this.loop){
        this.endTime = new Date().getTime() + 2 * 24 * 60 * 60 * 1000;
        localStorage.setItem(this.locaName, this.endTime)
      }else{
        clearInterval(this.timer);
        hours = 0;
        minutes = 0;
        seconds = 0;
      }
      
    }else{
      hours = Math.floor(distance / (1000 * 60 * 60));
      minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      seconds = Math.floor((distance % (1000 * 60)) / 1000);
    }

    this.displayElement.querySelector('.h').innerHTML = this.formatTime(hours)
    this.displayElement.querySelector('.m').innerHTML = this.formatTime(minutes)
    this.displayElement.querySelector('.s').innerHTML = this.formatTime(seconds)
  }
  formatTime(time) {
    return time < 10 ? `0${time}` : time;
  }
}

function btnShowLoading($p, isShow = true) {
  if (isShow) {
    $p.addClass('loading-btn-cus')
    $p.append('<span class="loading-span"></span>')
  } else {
    $p.removeClass('loading-btn-cus')
    $p.find('.loading-span').remove()
  }
}

// 加购处理回调
function addToCartPromise(productId, button, properties, code = '', quantity = 1) {
  return new Promise((resolve, reject) => {
    // 获取文本元素和加载动画元素
    var textElement;
    var loaderElement;
    console.log(button, '------44---2-');
    if (button) {
      console.log(button, '---3333------2-');
      textElement = button.querySelector('.loader-button__text');
      loaderElement = button.querySelector('.loader-button__loader');

      if (button.disabled) return;
      // 禁用按钮
      button.setAttribute("disabled", "disabled");
      button.setAttribute("aria-busy", "true");
      // 显示加载动画
      textElement.hidden = true;
      loaderElement.hidden = false;
    }

    console.log(222222, code, '----------');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity, // 可根据需求设置购买数量
        properties
      }),
    })
      .then(response => response.json())
      .then(data => {
        autoDiscountCode(code);
        // 获取购物车列表
        return fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => {
            cartData["sections"] = data["sections"];
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartData,
                openMiniCart: window.themeVariables.settings.cartType === "drawer"
              }
            }));

            if (button) {
              // 恢复按钮状态
              button.removeAttribute("disabled");
              button.removeAttribute("aria-busy");
              // 显示 "Add to Cart"，隐藏加载动画
              textElement.hidden = false;
              loaderElement.hidden = true;
            }

            // Resolve the Promise with the cart data
            resolve(cartData);
          });
      })
      .catch(error => {
        console.error('Error adding product to cart or getting cart contents:', error);

        if (button) {
          // 恢复按钮状态
          button.removeAttribute("disabled");
          button.removeAttribute("aria-busy");
          // 显示 "Add to Cart"，隐藏加载动画
          textElement.hidden = false;
          loaderElement.hidden = true;
        }

        // Reject the Promise with the error
        reject(error);
      });
  });
}
